/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BranchDto } from '../../models/branch-dto';
import { BranchUpdateDto } from '../../models/branch-update-dto';

export interface BranchAdminControllerUpdateV1$Params {
  id: string;
      body: BranchUpdateDto
}

export function branchAdminControllerUpdateV1(http: HttpClient, rootUrl: string, params: BranchAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BranchDto>> {
  const rb = new RequestBuilder(rootUrl, branchAdminControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BranchDto>;
    })
  );
}

branchAdminControllerUpdateV1.PATH = '/api/v1/branches/admin/{id}';
